import { store } from '@/common/root';
import Model from '@/common/models/common.model';
import Network from '@/common/models/network.model';
import {
  FloatingIp as FloatingIpSchema,
  DomainProject as DomainProjectSchema
} from '@schema';
import { FLOATING_IP_STATUS_MAP } from '@/common/constants/floatingIps.constants';

export interface NetworkDetails {
  id: string,
  name: string,
  physical_network: string | null,
  project_id: string,
  subnets: object[],
  shared: boolean,
  ipam_enabled: boolean,
  router_external: boolean,
  vlan_id: number,
  spoofing_protection: boolean,
  rbac_policies: object[],
  tags: string[],
  default_vnic_type: string
}

export default class FloatingIp extends Model {
  declare attributes: FloatingIpSchema;

  get statusIcon() {
    return FLOATING_IP_STATUS_MAP[this.status].icon;
  }

  get statusText() {
    return FLOATING_IP_STATUS_MAP[this.status].text;
  }

  get floatingIp() {
    return this.attributes.floating_ip_address;
  }

  get fixedIp() {
    return this.attributes.fixed_ip_address;
  }

  get assignedToName() {
    return this.attributes.attachment?.object_name;
  }

  get assignedTo(): ID {
    return this.attributes.attachment?.object_id || '';
  }

  get isAssignedToLb() {
    return this.attributes.attachment?.device_owner === FloatingIpSchema.device_owner.OCTAVIA;
  }

  get network(): Network {
    return (this.networkId && typeof store.getters['networks/getItemById'] === 'function'
      && store.getters['networks/getItemById'](this.networkId));
  }

  // TODO: pick correct interface from project getters
  get project(): DomainProjectSchema {
    return (typeof store.getters['projects/getItemById'] === 'function'
      && store.getters['projects/getItemById'](this.projectId)) || {};
  }

  get projectId() {
    return this.attributes.project_id;
  }

  get domainId() {
    return this.attributes.domain_id;
  }

  get projectName() {
    return this.project.name;
  }

  get networkId() {
    return this.attributes.floating_network_id;
  }

  get networkName() {
    return this.attributes.floating_network_name;
  }

  get portId() {
    return this.attributes.port_id;
  }

  get routerId() {
    return this.attributes.router_id;
  }
}
